export type DataExportSubject = 'participant' | 'guardian';

/** "digger-12-dados-2026-10-15.json", dated in Lisbon. */
export function dataExportFileName(subject: DataExportSubject, id: number, now: Date): string {
  const day = now.toLocaleDateString('sv-SE', { timeZone: 'Europe/Lisbon' });
  const who = subject === 'participant' ? 'digger' : 'encarregado';
  return `${who}-${id}-dados-${day}.json`;
}

/** Hands the browser a JSON file to save. */
export function saveJsonFile(fileName: string, data: unknown): void {
  const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
